import { JobStatusLabel } from 'services/jobs/jobs.model';
import { emitJobDelivered } from '../mock-job-stream';
import { MOCK_JOB_ROSTER, MockJobRosterEntry } from './mock-jobs-roster.const';

/**
 * Estado em memória dos jobs mock, compartilhado entre os domínios.
 * - mocks/jobs: lista/detalhe usam `allJobEntries()` e `currentJobStatus()`; POST /jobs usa `registerCreatedJob()`.
 * - mocks/contestacao e mocks/basilisk: abrir/concluir revisão chamam `setJobStatus()`.
 * Toda mudança de status é emitida no MOCK_JOB_STREAM (substituto do SSE), então as telas do Hub atualizam sozinhas.
 */
const statusOverrides = new Map<string, JobStatusLabel>();
const createdJobs: MockJobRosterEntry[] = [];

export function allJobEntries(): MockJobRosterEntry[] {
	return [...createdJobs, ...MOCK_JOB_ROSTER];
}

export function findJobEntry(jobId: string): MockJobRosterEntry | undefined {
	return allJobEntries().find((entry) => entry.id === jobId);
}

export function currentJobStatus(jobId: string): JobStatusLabel | undefined {
	return statusOverrides.get(jobId) ?? findJobEntry(jobId)?.status;
}

export function setJobStatus(
	jobId: string,
	status: JobStatusLabel,
	result: Record<string, unknown> = {},
) {
	statusOverrides.set(jobId, status);
	emitJobDelivered(jobId, status, result);
}

/** Registra um job criado pela UI (entra no topo da lista, com `createdDaysAgo: 0`) */
export function registerCreatedJob(entry: MockJobRosterEntry) {
	createdJobs.unshift(entry);
}
